let activeScrollLocks = [];
let previousBodyOverflowSetting;
let previousBodyPaddingRight;
function setOverflowHidden() {
  if (previousBodyPaddingRight === undefined) {
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollBarWidth > 0) {
      const computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'), 10);
      previousBodyPaddingRight = document.body.style.paddingRight;
      document.body.style.paddingRight = `${computedBodyPaddingRight + scrollBarWidth}px`;
    }
  }
  if (previousBodyOverflowSetting === undefined) {
    previousBodyOverflowSetting = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
}
function restoreOverflowSetting() {
  if (previousBodyPaddingRight !== undefined) {
    document.body.style.paddingRight = previousBodyPaddingRight;
    previousBodyPaddingRight = undefined;
  }
  if (previousBodyOverflowSetting !== undefined) {
    document.body.style.overflow = previousBodyOverflowSetting;
    previousBodyOverflowSetting = undefined;
  }
}
function disableBodyScroll(id) {
  if (!id || activeScrollLocks.some(lock => lock === id)) {
    return;
  }
  activeScrollLocks = [...activeScrollLocks, id];
  setOverflowHidden();
}
function enableBodyScroll(id) {
  if (!id || !activeScrollLocks.some(lock => lock === id)) {
    return;
  }
  activeScrollLocks = activeScrollLocks.filter(lockId => lockId !== id);
  if (activeScrollLocks.length === 0) {
    restoreOverflowSetting();
  }
}

export { disableBodyScroll, enableBodyScroll };
//# sourceMappingURL=body-scroll-lock.js.map
